export default "__VITE_ASSET__Ct_g8uFC__"